/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type actionButtonsTracking_item$ref = any;
export type actionButtonsTracking_item = {
    readonly serviceId: string | null;
    readonly pdpTrackingVpvParams?: unknown | null;
    readonly contemporaryTrackingString: string;
    readonly title: string | null;
    readonly vertical: VerticalType | null;
    readonly seller: {
        readonly serviceId: string | null;
    } | null;
    readonly pricing: {
        readonly totalAmount: {
            readonly amount: number | null;
        } | null;
    } | null;
    readonly categoryCode: string | null;
    readonly browseUrl: string | null;
    readonly " $refType": actionButtonsTracking_item$ref;
};



const node: ReaderFragment = (function () {
    var v0 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Fragment",
        "name": "actionButtonsTracking_item",
        "type": "Item",
        "metadata": null,
        "argumentDefinitions": [
            {
                "kind": "RootArgument",
                "name": "userId",
                "type": "String"
            },
            {
                "kind": "RootArgument",
                "name": "isClient",
                "type": "Boolean"
            }
        ],
        "selections": [
            (v0 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "contemporaryTrackingString",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "title",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "vertical",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "seller",
                "storageKey": null,
                "args": null,
                "concreteType": "Seller",
                "plural": false,
                "selections": [
                    (v0 /*: any*/)
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "pricing",
                "storageKey": null,
                "args": null,
                "concreteType": "ItemPricing",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "totalAmount",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "amount",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "categoryCode",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "browseUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "Condition",
                "passingValue": true,
                "condition": "isClient",
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "pdpTrackingVpvParams",
                        "args": [
                            {
                                "kind": "Variable",
                                "name": "userId",
                                "variableName": "userId"
                            }
                        ],
                        "storageKey": null
                    }
                ]
            }
        ]
    } as any;
})();
(node as any).hash = 'a05febc54fb8ba383903d7261c92ec5f';
export default node;
